var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66536 9.29004V1.99137C2.66532 1.83626 2.71679 1.68552 2.81171 1.56283C2.90663 1.44014 3.0396 1.35246 3.18976 1.31354C3.33992 1.27463 3.49875 1.2867 3.6413 1.34784C3.78386 1.40899 3.90207 1.51576 3.97736 1.65137L8.02002 8.92871C8.09532 9.06432 8.21353 9.17109 8.35608 9.23224C8.49864 9.29338 8.65747 9.30545 8.80763 9.26653C8.95778 9.22762 9.09076 9.13994 9.18568 9.01725C9.28059 8.89456 9.33207 8.74382 9.33202 8.58871V1.29004M1.33203 3.95671H10.6654M1.33203 6.62337H10.6654",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.16e7ca9f8f327e09bf20de5f1ef6d0f4.svg";
export { ForwardRef as ReactComponent };